///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class BonusVideoScreen extends BaseScreen {

        private video:Phaser.GameObjects.Video;
        private gamewillcontinue_label:Phaser.GameObjects.Text;

        private onContinue:()=>void;

        private isVideoPreloaded:boolean = false;
        private isVideoAllowedToShow:boolean = false;
        private wait_ico:Phaser.GameObjects.Image = null;
        private bonusVideoBG:Phaser.GameObjects.Image = null;
        private bonusVideoFG:Phaser.GameObjects.Image = null;

        constructor(scene:Phaser.Scene, onContinue:()=>void) {
            super(scene);

            this.onContinue = onContinue;

            this.bonusVideoBG = new Phaser.GameObjects.Image(this.scene, game.scale.width/2-0.5, game.scale.height/2-0.5, 'stories', 'bonusVideoBG'+'0000');
            this.bonusVideoBG.setOrigin(0.5, 0.5);
            this.add(this.bonusVideoBG);

            this.bonusVideoFG = new Phaser.GameObjects.Image(this.scene, -1, 0, 'stories', 'bonusVideoFG'+'0000');
            this.bonusVideoFG.setOrigin(0, 0);
            this.add(this.bonusVideoFG);

            let MCdonaldsIcon = new Phaser.GameObjects.Image(this.scene, 150, 152, 'stories', 'MCdonaldsIcon'+'0000');
            this.add(MCdonaldsIcon);
            MCdonaldsIcon.y = 500;
            MCdonaldsIcon.scaleY = 0.9;
            this.scene.tweens.add({
                targets: MCdonaldsIcon,
                y: 152,
                scaleY: 1,
                duration: 350
            });

            let youerned_label = this.scene.add.text(game.scale.width/2 + 90, 170, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 28,
                "color": "#FFFFFF",
                "align": 'center'
            });
            youerned_label.setWordWrapWidth(150);
            youerned_label.setShadow(2, 4, '#666666', 4);
            youerned_label.setOrigin(0.5, 0.5);
            this.add(youerned_label);
            nscs.gameplay.Gameplay.setText(youerned_label, 'vid1', false);

            youerned_label.y = -200;
            youerned_label.scaleY = 0.9;
            this.scene.tweens.add({
                targets: youerned_label,
                y: 170,
                scaleY: 1,
                duration: 350
            });

            this.gamewillcontinue_label = this.scene.add.text(game.scale.width/2, 300, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 20,
                "color": "#000000",
                "align": 'center'
            });
            this.gamewillcontinue_label.setOrigin(0.5, 0.5);
            this.add(this.gamewillcontinue_label);

            if (game.cache.video.has("McCruelt_I_am_Hating_It")) {
                this.isVideoPreloaded = true;
            } else {
                this.isVideoPreloaded = false;
                this.scene.load.video('McCruelt_I_am_Hating_It', 'assets/video/McCruelt_I_am_Hating_It.mp4', 'loadeddata', false, false);
                this.scene.load.once('complete', () => {
                    this.isVideoPreloaded = true;
                    this.tryToShowVideo();
                });
                this.scene.load.start();
            }

            nscs.util.Functions.delayedCall(3000, ()=>{
                this.scene.tweens.add({
                    targets: MCdonaldsIcon,
                    y: 500,
                    scaleY: 0.9,
                    duration: 950,
                    ease:Phaser.Math.Easing.Back.Out
                });
                this.scene.tweens.add({
                    targets: youerned_label,
                    x: 600,
                    angle:-90,
                    scaleY: 0.9,
                    duration: 950,
                    ease:Phaser.Math.Easing.Back.Out
                });

                nscs.util.Functions.delayedCall(1000, ()=>{
                    this.wait_ico = new Phaser.GameObjects.Image(this.scene, game.scale.width/2, game.scale.height/2, 'stories', 'wait_ico'+'0000');
                    this.add(this.wait_ico);
                    this.scene.tweens.add({
                        targets: this.wait_ico,
                        angle: 360,
                        duration: 3000,
                        ease:Phaser.Math.Easing.Linear,
                        repeat: -1
                    });
                    this.isVideoAllowedToShow = true;

                    let repeat:number = 30;
                    let timerEvent: Phaser.Time.TimerEvent = this.scene.time.addEvent({ delay: 1000, repeat: repeat });
                    timerEvent.callback = ()=>{
                        this.onTick(timerEvent.repeatCount);

                        if (timerEvent.repeatCount == 0) {
                            this.scene.tweens.killTweensOf(this.wait_ico);
                            this.remove(this.wait_ico);
                            this.remove(this.gamewillcontinue_label);

                            let btnContinue = new Phaser.GameObjects.Container(this.scene, game.scale.width/2, 290);
                            this.add(btnContinue);

                            let btnContinueGame = new Phaser.GameObjects.Image(this.scene, 0, 0, 'stories', 'btnContinueGame'+'0000');
                            btnContinue.add(btnContinueGame);
                            btnContinueGame.setInteractive({cursor: 'pointer'});
                            btnContinueGame.once('pointerup', () => {
                                if (this.onContinue) {
                                    this.onContinue();
                                    this.onContinue = null;
                                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                                }
                            });
                            let continue_label = this.scene.add.text(0, -3, "", {
                                "fontFamily": "Helvetica Rounded LT Black",
                                "fontSize": 20,
                                "color": "#FFFFFF",
                                "align": 'center'
                            });
                            continue_label.setOrigin(0.5, 0.5);
                            btnContinue.add(continue_label);
                            nscs.gameplay.Gameplay.setText(continue_label, 'vid3');

                            btnContinue.scale = 0.25;
                            this.scene.tweens.add({
                                targets: btnContinue,
                                scale: 1,
                                duration: 500,
                                ease:Phaser.Math.Easing.Back.Out
                            });
                        }
                    };

                });
            });

        }

        private tryToShowVideo():void {
            if (this.isVideoPreloaded && this.isVideoAllowedToShow) {
                this.showVideo();
                this.isVideoAllowedToShow = false;
            }
        }

        private showVideo():void {
            this.video = this.scene.add.video(game.scale.width/2, game.scale.height/2, 'McCruelt_I_am_Hating_It') as Phaser.GameObjects.Video;
            this.video.setOrigin(0.5, 0.5);
            this.video.setInteractive(/*{ cursor: 'pointer' }*/);
            this.addAt(this.video, this.getIndex(this.bonusVideoBG) + 1);
            this.add(this.video);
            this.video.play(false);
        }

        private onTick(sec:number):void {
            this.tryToShowVideo();
            if (this.video) {
                this.wait_ico.visible = false;
                if (this.video.isPaused()) {
                    this.video.setPaused(false);
                }
                if (this.video.isMuted() != nscs.sound.SoundManager.getInstance().muted) {
                    this.video.setMute(nscs.sound.SoundManager.getInstance().muted);
                }
            } else {
                this.wait_ico.visible = true;
            }

            nscs.gameplay.Gameplay.setText(this.gamewillcontinue_label, 'vid2');
            nscs.util.Functions.updateTextFieldPosition(this.gamewillcontinue_label, this.gamewillcontinue_label.text + " " + sec);
        }
    }
}